module.exports = __webpack_public_path__ + "9c2930773cc45bc8a55c3a7cd088ef41.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-2009.png
// module id = 520
// module chunks = 0